import * as React from 'react'

import { Box, Chevron, type DirectionType } from '@factorialco/deprecated-design-system'

interface Props {
  onClick: () => void
  open: boolean
}

export function Bar({ onClick, open }: Props) {
  const direction: DirectionType = open ? 'up' : 'down'

  return (
    <Box
      onClick={onClick}
      height="s32"
      border={{ top: { style: 'solid', width: 's1', color: 'grey400' } }}
      flexDirection="column"
      alignItems="flexEnd"
      justifyContent="center"
      paddingRight="s24"
      cursor="pointer"
    >
      <Chevron direction={direction} type="terciary" />
    </Box>
  )
}
